const variantsBlocks = document.querySelectorAll('.variants-block');
const variantsBlockTabsContent = document.querySelectorAll('.variants-block__tabs-content');

if (variantsBlocks.length) {
    [].forEach.call(variantsBlocks, variantsBlock => {
        const tabLinks = variantsBlock.querySelectorAll('.variants-block__tabs-navigation a');

        [].forEach.call(tabLinks, tabLink => {
            tabLink.addEventListener('click', (e) => {
                e.preventDefault();
                const tabLinkId = tabLink.dataset.id;

                tabLinkClassToggle(tabLinks, tabLink);
                tabContentVisibility(tabLinkId);
            });
        });
    });
}

tabLinkClassToggle = (allTabLinks, tabLink) => {
    [].forEach.call(allTabLinks, link => {
        link.parentElement.classList.remove('active')
    });

    tabLink.parentElement.classList.add('active');
};

tabContentVisibility = (tabLinkId) => {
    [].forEach.call(variantsBlockTabsContent, variantsBlockTabsContent => {
        variantsBlockTabsContent.classList.remove('active')
    });

    document.querySelector(`${tabLinkId}`).classList.add('active');
};